"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "sover": {
    "48c14fa0": [{
      "hkey": "af0581a6",
      "slug": "piazzoli",
      "name": "Piazzoli",
      "primary": true,
      "skipSearch": false
    }],
    "piazzolo": [{
      "hkey": "af0581a6",
      "slug": "piazzoli",
      "name": "Piazzoli",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "c1bdff5b": [{
      "hkey": "1c687e45",
      "slug": "settefontane",
      "name": "Settefontane",
      "primary": true,
      "skipSearch": false
    }],
    "sette-fontane": [{
      "hkey": "1c687e45",
      "slug": "settefontane",
      "name": "Settefontane",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;